
 const config = require("../env.json")

export const validarSesion=(Respuesta)=>{
    /*if(Respuesta==401)
    {
        console.info('validarSesion');
        localStorage.removeItem('user');
      
    }
    return '';
    */
    if (Respuesta === 401 || Respuesta === 403) {
        try { localStorage.removeItem('user'); localStorage.removeItem('token'); } catch {}
        // evita que el usuario vuelva con "Atrás" a la página rota
        window.location.replace('/login?reason=session');
        throw new Error(`auth_${Respuesta}`); // corta el flujo
      }

}

export const loginAcceso=async({Usuario,Contrasena})=>{
    
    const url=config.REACT_APP_WEBAPI_URL+`/auth/login`;
    const resp=await fetch(url,{
        method:'POST',
        mode:'cors',
        cache:'no-cache',
        headers: {
            'Content-Type': 'application/json'
                        
        },
        body:JSON.stringify({Usuario,Contrasena})
       
    });
    
    const respuesta=await resp.json();
    return respuesta;

};  

export const recuperarAcceso=async({UsuarioOCorreo})=>{
    
    const url=config.REACT_APP_WEBAPI_URL+`/auth/recuperar`;
    const resp=await fetch(url,{
        method:'POST',
        mode:'cors',
        cache:'no-cache',
        headers: {
            'Content-Type': 'application/json'
                        
        },
        body:JSON.stringify({UsuarioOCorreo})
       
    });
    
    const respuesta=await resp.json();
    return respuesta;

};

export const modificarContrasena=async({Contrasena,ContrasenaConfirmacion},token)=>{
    
    const parametros={Contrasena,ContrasenaConfirmacion};
    const url=config.REACT_APP_WEBAPI_URL+`/auth/ACTUALIZARCONTRASENA`;
    const resp=await fetch(url,{
        method:'PATCH',
        mode:'cors',
        cache:'no-cache',
        headers:{
            'Content-Type':'application/json',        
            'x-token':token
                
            
        },
        body:JSON.stringify(parametros)
       
    });
    if(resp.status==401){
        
        return {sessionover:1};
    }
    const respuesta=await resp.json();
    return respuesta;

};    